import Profile from '@/services/profile'
import {formatErrors} from '@utils/errors-alert'
import {bus} from '@/plugins/event-bus'
import {logout} from '@utils/auth'
import subdomain from '@utils/subdomain'

const fetch = async ({commit}) => {
  return new Promise((resolve, reject) => {
    Profile.fetch().then((response) => {
      if (response.data.user_type === 'Cedente') {
        logout()
        const mainURI = window.location.host.split('.')
        const domain = mainURI.length > 2 ? mainURI.slice(-3).join('.') : mainURI[1]
        const protocol = process.env.PROTOCOL
        window.location.href = `${protocol}fornecedores.${subdomain}.${domain}`
        return
      }
      commit('SET_CURRENT_USER', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = ({ commit }, user) => {
  return new Promise((resolve, reject) => {
    Profile.save(user).then((response) => {
      commit('SET_CURRENT_USER', response.data)
      resolve(response.data)
    })
    .catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  fetch,
  save
}



// WEBPACK FOOTER //
// ./src/features/profile/store/actions.js